import React, { useState } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { useAuth } from '../App';
import { toast } from 'sonner';

export default function Login() {
  const { login, user } = useAuth();
  const [email, setEmail] = useState('info@rishikasharma.com');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();
  if (user) return <Navigate to="/" replace />;
  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try { await login(email, password); nav('/'); }
    catch (err) { toast.error('Invalid credentials'); }
    finally { setLoading(false); }
  };
  return (
    <div className="min-h-screen flex items-center justify-center px-6" style={{background:'var(--cream)'}}>
      <div className="w-full max-w-sm">
        <div className="text-center mb-10">
          <div className="serif text-[38px] leading-none" style={{color:'var(--charcoal)'}}>Rishika Sharma</div>
          <div className="eyebrow mt-2">Professional Makeup Artist</div>
          <div className="gold-rule my-6 mx-auto" style={{width:60}} />
          <div className="serif italic text-[15px]" style={{color:'var(--gold)'}}>Elegance Defined. Beauty Refined.</div>
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="eyebrow block mb-1">Email</label>
            <input value={email} onChange={e => setEmail(e.target.value)} type="email" required data-testid="login-email" />
          </div>
          <div>
            <label className="eyebrow block mb-1">Password</label>
            <input value={password} onChange={e => setPassword(e.target.value)} type="password" required data-testid="login-password" />
          </div>
          <button type="submit" className="btn-gold w-full" disabled={loading} data-testid="login-submit">
            {loading ? 'Signing in…' : 'Sign In'}
          </button>
        </form>
        <div className="text-center text-[11px] text-[var(--muted)] mt-8 tracking-[0.14em] uppercase">Gurugram | Available Worldwide</div>
      </div>
    </div>
  );
}
